// ** React Imports
import { useEffect, useRef } from "react";

// ** Redux & Store & Actions
import { useDispatch, useSelector } from "react-redux";

// ** react-router-dom Imports
import { useLocation } from "react-router-dom";

// ** Custom Global Components
import Icon from "components/global/Icon";
import ModalAuthContent from "./ModalAuthContent";

// ** Custom hooks
import useOnClickOutside from "hooks/useOnClickOutside";

// ** Styled Components
import { StyledCloseButton } from "components/layout/Modal";
import { StyledModalAuthWrapper } from "./styles/ModalAuthWrapper.styled";

// ** SVG Static Imports
import { ReactComponent as LightTimes } from "resources/icons/light/times.svg";
import { StyledModalAuthComponent } from "./styles/ModalAuthComponent.styled";
import { closeAuthModal } from "store/modules/global-common.slice";

// #####################################################

const ModalAuth = () => {
	const dispatch = useDispatch();
	const location = useLocation();

	const isOpen = useSelector((state) => state.globalCommon.authModal.isOpen);
	const prevPathnameRef = useRef(location.pathname);

	// ** Referencje do komponentu modala
	const modalComponentRef = useRef(null);

	// ** Zamknięcie modala po kliknięciu poza nim
	const handleCloseModalOnOutsideClick = useOnClickOutside(
		modalComponentRef,
		(e) => {
			if (
				e.offsetX < e.target.clientWidth &&
				!e.target.closest('[motiondivattribute="motionDiv"]')
			) {
				// ** Warunek sprawdzający czy kliknięto prawym przyciskiem myszy - jeśli tak to nie zamyka modala
				if (e.which !== 3) {
					dispatch(closeAuthModal());
				}
			}
		}
	);

	const closeButton = () => {
		return (
			<StyledCloseButton
				label="Close"
				onClick={() => {
					dispatch(closeAuthModal());
				}}
			>
				<Icon icon="times" type="fal" svgIconComponent={LightTimes} />
			</StyledCloseButton>
		);
	};

	// ** Automatyczne zamykanie modala przy zmianie ścieżki
	useEffect(() => {
		if (prevPathnameRef.current !== location.pathname) {
			if (isOpen) {
				dispatch(closeAuthModal());
			}
			prevPathnameRef.current = location.pathname;
		}

		return () => {
			dispatch(closeAuthModal());
		};
	}, [location.pathname, dispatch, isOpen]);

	// #####################################################
	return (
		<StyledModalAuthWrapper
			onClick={handleCloseModalOnOutsideClick}
			className="landingAlwaysLight"
		>
			{/* Wyświetlanie przycisku 'Close' na Desktop */}
			{closeButton()}
			<StyledModalAuthComponent>
				<ModalAuthContent innerRef={modalComponentRef} />
			</StyledModalAuthComponent>
		</StyledModalAuthWrapper>
	);
};

// #####################################################

export default ModalAuth;

// #####################################################
